import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Table, Offcanvas, Button } from 'react-bootstrap'
import { FaPlus } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import Paginator from "../../components/common/Pagination"
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import ChannelPartnerFilter from "./ChannelPartnerFilter";

const ChannelPartnerList = () => {
    const [chPrtnerList,setChPartnerList] = useState([])
    const [showFilter, setShowFilter] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [count,setCount]=useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [showDt, setShowDt] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [filters, setFilters] = useState({});
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken,logout } = useContext(UserContext);
    const headers = { "auth-token": authToken, authorization: accessToken };
    const navigate = useNavigate();
    const permissionscontext = useMenuPermissions('/admin/channel-partner');
    const limit = 10;
    

    useEffect(() => {
        fetchChPaList(currentPage, filters);
      }, [currentPage, filters]);


    const fetchChPaList = async (page = 1, filters) => {
      const params = {
        ...filters,
        offset: (page - 1) * limit,
        limit: limit,
      };

      const queryString = Object.entries(params)
        .filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      try {
        const response = await APIServices.get(
          `/admin/channel_partner/list?${queryString}`,
          headers
        );
        if (response?.status === 200) {
          const roleList = response?.data?.list || [];
          setChPartnerList(roleList);
          setCount(response?.data?.count);
          const totalItems = response?.data?.count || 0;
          setTotalCount(Math.ceil(totalItems / limit));
        } else if (response?.status === 401) {
          logout();
          navigate("/");
        } else {
          setChPartnerList([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setChPartnerList([]);
        setTotalCount(0);
      }
    };

    const handleStatusChange = async (chPatner) => {
      const newStatus = chPatner.status === "Active" ? "Inactive" : "Active";
      try {
        const payload = { id: chPatner.id, status: newStatus };
        const res = await APIServices.post(
          `/admin/channel_partner/status_update`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          const updatedChPartenerList = chPrtnerList.map((item) =>
            item.id === chPatner.id ? { ...item, status: newStatus } : item
          );
          setChPartnerList(updatedChPartenerList);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      } catch (error) {
        showToast("Error updating status", "error");
      }
    };      
    

    const handleDeleteChPartner = async () => {
      try {
        if (selectedUser !== null) {
          const payload = { id: selectedUser };
          const res = await APIServices.post(
            `/admin/channel_partner/delete`,
            payload,
            headers
          );
          if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            const updatedChPartenerList = chPrtnerList.filter((chPatner) => chPatner.id !== selectedUser);
            setChPartnerList(updatedChPartenerList);
            setSelectedUser(null);
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
          }
        }
        setShowDt(false);
      } catch (error) {
        console.error("Error deleting FAQ:", error);
      }
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const showToast = (message, type) => {
      toast(message, {
        position: "top-right",
        autoClose: 2000,
        type,
        hideProgressBar: false,
        closeOnClick: true,
      });
    };

      
    return (
      <>
        {permissionscontext.view ? (
          <>
            <div className="momList_inner todo_list_inner cp_list_inner ">
              <div className="mom_header d-flex align-items-center justify-content-between mb-3">
                <h1 className="font_blue_18 font-600">{`Channel Partner (${count})`}</h1>

                <ul className="d-flex align-items-center mom_filter">
                  <li
                    className="d-flex align-items-center cursor-pointer"
                    onClick={() => setShowFilter(true)}
                  >
                    Filter By{" "}
                    <img
                      src="/images/Sort.svg"
                      className="img-fluid ms-2"
                      alt="Sort"
                    />
                  </li>
                  <li>
                    <button
                      className="btn red_button d-flex align-items-center"
                      onClick={() => navigate("/admin/add-channel")}
                      disabled={!permissionscontext.add}
                    >
                      <FaPlus className="me-1" /> Add Channel Partner
                    </button>
                  </li>
                </ul>
              </div>

              <div className="todoList_table">
                <div className="table-responsive">
                  <Table>
                    <thead className="table-dark">
                      <tr>
                        <th>Sr.No</th>
                        <th>Channel Partner</th>
                        <th>Email</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {chPrtnerList && chPrtnerList?.length > 0 ? (
                    <>
                    <tbody>
                      {chPrtnerList.map((user, index) => (
                        <tr key={user.id}>
                          <td>{(currentPage - 1) * limit + index + 1}</td>
                          <td
                            onClick={() =>
                              navigate(`/admin/channel-details/${user.id}`)
                            }
                          >
                            <Link to="/ChannelDetails">
                              <div className="d-flex align-items-center">
                                <p className="textTransform">{user.name}</p>
                              </div>
                            </Link>
                          </td>
                          <td>{user.email ? user.email : "N/A"}</td>
                          <td>{user.channel_partner_type ? user.channel_partner_type : "N/A" }</td>

                          <td>
                            <Form className="Switch_toggle">
                              <input
                                type="checkbox"
                                id={`switch-${user.id}`}
                                checked={user.status === "Active"}
                                onClick={() => handleStatusChange(user)}
                                disabled={!permissionscontext.edit}
                              />
                              <label
                                className="position-relative"
                                htmlFor={`switch-${user.id}`}
                              >
                                Toggle
                              </label>
                            </Form>
                          </td>

                          <td>
                            <ul className="d-flex align-items-center justify-content-end gap-2">
                              <li>
                                <button
                                  disabled={!permissionscontext.delete}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    cursor: !permissionscontext.delete
                                      ? "not-allowed"
                                      : "pointer",
                                    opacity: !permissionscontext.delete
                                      ? 0.5
                                      : 1,
                                  }}
                                  onClick={() => {
                                    setSelectedUser(user.id);
                                    setShowDt(true);
                                  }}
                                >
                                  <img
                                    src="/images/Trash.svg"
                                    className={`img-fluid trash`}
                                    alt="trash"
                                  />
                                </button>
                              </li>
                              <li>
                                <button
                                  disabled={!permissionscontext.edit}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                    cursor: !permissionscontext.edit
                                      ? "not-allowed"
                                      : "pointer",
                                    opacity: !permissionscontext.edit
                                      ? 0.5
                                      : 1,
                                  }}
                                  onClick={() =>
                                    navigate(
                                      `/admin/update-channel/${user.id}`,
                                      {
                                        state: { row: user },
                                      }
                                    )
                                  }
                                >
                                  <img
                                    src="/images/Pen.svg"
                                    className={`img-fluid pen`}
                                    alt="pen"
                                  />
                                </button>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    </>
                    ) : (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan="6" className="border-0">
                              <div className="d-flex align-items-center justify-content-center mt-5">
                                <h4>Not Available</h4>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
              </div>
              {showFilter && (
                <ChannelPartnerFilter
                  appliedFilters={filters}
                  show={showFilter}
                  onHide={() => setShowFilter(false)}
                  onApplyFilter={(filterData) => {
                    setFilters(filterData);
                    setShowFilter(false);
                  }}
                  onClear={() => {
                    setFilters({});
                    setShowFilter(false);
                  }}
                />
              )}
              { count > 10 && (
              <Paginator
                currentPage={currentPage}
                totalPages={totalCount}
                onPageChange={handlePageChange}
              />
              )}
            </div>
            <DeleteModal
              showdt={showDt}
              handleCloseDt={() => setShowDt(false)}
              handledelete={handleDeleteChPartner}
            />
            <ToastContainer />
          </>
        ) : (
          <Notauthorized />
        )}
      </>
    );
}

export default ChannelPartnerList